export const MAX_STEP = 3;

export const DEFAULT_PAGE_SIZE = 100;
export const DEFAULT_PAGE = 1;
